import { gql } from '@apollo/client';

export const fetchUsageAggregationHistory = gql`
  query fetchUsageAggregationHistory($entitlementId: String!, $transactionAccountId: String) {
    entitlementDetails(filters: { transactionAccountId: $transactionAccountId }) {
      usageAggregation(entitlementId: $entitlementId) {
        period {
          startTime
          endTime
        }
        results {
          latestUsage
          periodTimestamp
          usersAdded
          usersRemoved
          maxUsage
          highWaterMarkUsage
        }
      }
    }
  }
`;
